import JumpStartView from '../views/JumpStart';
import JumpStartIndex from '../views/jump-start/Index';
// import WeeklyTraining from '../views/training/WeeklyTraining';

export const JUMP_START_ROUTES = {
  path: '/jump-start',
  component: JumpStartView,
  meta: { title: 'Jump Start' },
  children: [
    {
      path: '',
      name: 'jump-start',
      component: JumpStartIndex,
      meta: { title: 'Jump Start' }
    },
    {
      path: ':id',
      name: 'jump-start-inner',
      component: JumpStartIndex,
      meta: { title: 'Jump Start' }
    },
  ],
  // {
  //   path: '/training/weekly',
  //   name: 'weekly-training',
  //   component: WeeklyTraining,
  //   meta: {title: 'Weekly Training'}
  // },
};
